import { guid } from "@progress/kendo-react-common";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import useConfiguration from "../../../hooks/useConfiguration";
import useSessionStorage from "../../../hooks/useSessionStorage";
import BackAlterButton from "../../common/BackAlterButton/BackAlterButton";
import BackFixedButton from "../../common/BackFixedButton/BackFixedButton";
import Header from "../../common/Header";
import Loader from "../../common/Loader";
import Sidebar from "../../common/Sidebar";
import Spinner from "../../common/Spinner/spinner";
import * as Toasts from "../../common/Toastify";
import {
  editPost,
  getDynamicFormData,
  pushToSummary,
  saveJobInfo,
  setErrorInfo,
  setJobDescription,
  setSaveAPIErrors,
  updateMatchingCandidateData,
  updateDynamicFormData,
  resetJobOpportunityInfo
} from "../action";
import {
  validatDynamicForm,
  validateCertificationInfo,
  validateCovidInfo,
  validateDepsUnits,
  validateEMREHRInfo,
  validateEducationInfo,
  validateJobInfo,
  validateJobType,
  validateLocationInfo,
  validateMedicalSpecialityInfo,
  validateOvetimeAllowed,
  validatePayRateInfo,
  validateShiftInfo,
  validateStartJob,
  validateTemplateInfo,
} from "../jobOpportunityUtils";
import { jobOpportunitySelector } from "../selector";
import {
  setResetDropdown,
  setjobMultishiftOccurreneUpdateList,
} from "../slice";
import ApprovelUserslist from "./ApprovelUserslist";
import EMREHRExperience from "./EMREHRExperience";
import { getJobDetails } from "./action";
import Certification from "./certification";
import ClaimedCandidateInfo from "./claimedCandidateInfo";
import CovidVaccine from "./covidVaccine";
import Education from "./education";
import "./index.css";
import JobInfo from "./jobInfo";
import JobLocation from "./jobLocation";
import JobType from "./jobType";
import MedicalSpeciality from "./medicalSpeciality";
import OccurrenceDetail from "./occurrenceDetail";
import { jobDetailsSelector } from "./selector";
import Shift from "./shift";
import SummaryDyanamicJob from "./summaryDyanamicJob";
import TemplateInfo from "./templateInfo";
import AutoRepost from "./autoRepost";
import { updateJobSaveAPIErrors } from '../slice'
import OvertimeAllowed from "./OvertimeAllowed";
import DepsUnitsSummary from "./depsUnitsSummary";
import PayRateSummary from "./payRate";
import { payRateTypeObj } from "../../../helpers/data";
// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
  const {
    jobDetails,
    jobId,
    dataLoaded,
    backPath,
    editMode,
    loadingFlagSummary,
  } = useSelector(jobDetailsSelector);
  const {
    jobType,
    startJob,
    location,
    shift,
    jobInfo,
    education,
    medicalSpeciality,
    certification,
    emrEhrSystemExperience,
    covidVaccinationStatus,
    templateInfo,
    jobSaveError,
    errors,
    masterData,
    loadJobId,
    navigateMatchingCandidate,
    matchingJobid,
    selectedOption,
    dropDownJobId,
    formdata,
    recursionFlag,
    rrurle,
    rrurleStr,
    jobMultishiftOccurreneUpdateList,
    jobUnique,
    jobCode,
    editJobUniqueId,
    selectedAuthUsers,
    loadingFlag,
    encounterCalculation,
    isAutoPostAllowed,
    checkMarkup,
    isOvertimeAllowed,
    depsUnits,
    payRateType,
    payRateTotalShiftAmount,
    payRateOccurrenceAmount
  } = useSelector(jobOpportunitySelector);

  const JobEncounterOccurreneUpdateList = useSelector(
    (state) => state.jobOpportunity.JobEncounterOccurreneUpdateList
  );
  const storage = useSessionStorage();
  const routlocation = useLocation();
  const login = storage.getItem("login");
  const config = useConfiguration();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { jobUniqueId, jobShiftUniqueId, shiftType } = routlocation.state || "";

  const {
    gotoMatching,
    acceptableTravelDistance,
    jobDate,
    jobsClaimId,
    postion,
    PageName
  } = routlocation.state || "";
  console.log('postion', postion);
  const { save } = routlocation.state || "";
  const [filterJobList, setFilterJobList] = useState({});
  const inputTypes = storage.getItem("inputTypes");
  const jobDetailsTopRef = useRef(null);
  // jobUniqueId ? jobUniqueId : editJobUniqueId,
  const resetVal = () => {
    const newVal = JSON.parse(JSON.stringify(formdata));
    newVal.forEach((item) => {
      item.controlsInfo.forEach((val, index) => {
        // commonselctRef?.current[`${item.formId}-${index}`]?.resetSelectedValues();
      });
    });
    dispatch(updateDynamicFormData(newVal)).then(() => {
      dispatch(resetJobOpportunityInfo());
    });
  };
  useEffect(() => {
    document.title = "Job Details";
    if (config.baseUrl) {
      if (!login) {
        navigate("/");
      } else {
        if (jobUniqueId) {
          dispatch(
            getJobDetails(config.baseUrl, jobUniqueId, jobDate, jobsClaimId)
          )
        }
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [config, jobUniqueId]);

  if (matchingJobid && navigateMatchingCandidate && editJobUniqueId) {
    if (recursionFlag?.toString() !== "2") {
      //resetVal()
      navigate("/matchingcandidate", {
        state: {
          matchingJobid,
          acceptableTravelDistance: acceptableTravelDistance,
          jobUniqueId: editJobUniqueId,
          createJobPage: !loadJobId ? true : false,
          NoOfShiftsneeded: !loadJobId ? true : false,
          previousPath: '/jobopportunity',
          postion: postion
        },
      });
    }
  }

  const scrollToTop = () => {
    jobDetailsTopRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    if (gotoMatching === true) {
      scrollToTop();
    }
  }, [gotoMatching]);

  useEffect(() => {
    return () => {
      dispatch(updateMatchingCandidateData("", false));
      dispatch(updateJobSaveAPIErrors(''));
    };
  }, []);

  useEffect(() => {
    let filterVal = [];
    if (dropDownJobId) {
      filterVal = login.jobTypeFlags.jobTypeList.filter(
        (item) => item.jobTypeId === dropDownJobId
      )[0];
      if (filterVal) {
        setFilterJobList(filterVal);
      }
    } else {
      filterVal = login.jobTypeFlags.jobTypeList[0]; // login.jobTypeFlags.jobTypeList.map(item => item.jobTypeId);

      if (filterVal) {
        setFilterJobList(filterVal);
      }
    }
  }, [dropDownJobId]);

  const evaluateSaveType = (selectedOption) => {
    if (selectedOption.newPost) {
      return 1;
    }
    if (selectedOption.fromTemplate) {
      return 2;
    }
    if (selectedOption.createTemplate) {
      return 3;
    }
    return 0;
  };

  const postJob = (navigateToSummary = true) => {
    const navigateToMatchingCandidate = false;
    const saveType = evaluateSaveType(selectedOption);
    dispatch(setSaveAPIErrors("")).then(() => {
      dispatch(
        saveJobInfo(
          `${config.baseUrl}`,
          jobType,
          startJob,
          location,
          shift,
          jobInfo,
          education,
          medicalSpeciality,
          certification,
          emrEhrSystemExperience,
          covidVaccinationStatus,
          templateInfo,
          login.employerId,
          loadJobId,
          navigateToMatchingCandidate,
          saveType,
          filterJobList,
          formdata,
          recursionFlag,
          rrurle,
          jobMultishiftOccurreneUpdateList,
          JobEncounterOccurreneUpdateList,
          jobUnique,
          jobCode,
          encounterCalculation,
          isAutoPostAllowed,
          isOvertimeAllowed,
          depsUnits,
          payRateType,
          payRateTotalShiftAmount,
          payRateOccurrenceAmount
        )
      )
        .then((response) => {
          if (
            response?.message ===
            "Job Template Name already exists..! Please give another name"
          ) {
            // Toasts.error(response?.message);
            return;
          } else {
            Toasts.success(response?.message);
            setTimeout(() => {
              navigateToSummary && navigate("/openshifts");
            }, 3000);
          }
        })
        .catch((error) => {
          dispatch(setSaveAPIErrors(error.message));
          window.scrollTo(0, 0);
        });
    });
  };

  const saveJobMatching = (navigateToSummary = true) => {
    const navigateToMatchingCandidate = true;
    const saveType = evaluateSaveType(selectedOption);

    if (save) {
      dispatch(setSaveAPIErrors("")).then(() => {
        dispatch(
          saveJobInfo(
            `${config.baseUrl}`,
            jobType,
            startJob,
            location,
            shift,
            jobInfo,
            education,
            medicalSpeciality,
            certification,
            emrEhrSystemExperience,
            covidVaccinationStatus,
            templateInfo,
            login.employerId,
            loadJobId,
            navigateToMatchingCandidate,
            saveType,
            filterJobList,
            formdata,
            recursionFlag,
            rrurle,
            jobMultishiftOccurreneUpdateList,
            JobEncounterOccurreneUpdateList,
            jobUnique,
            jobCode,
            encounterCalculation,
            isAutoPostAllowed,
            isOvertimeAllowed,
            depsUnits,
            payRateType,
            payRateTotalShiftAmount,
            payRateOccurrenceAmount
          )
        )
          .then((response) => {

            if (parseInt(response?.result) === 1) {
              setTimeout(() => {
                navigateToSummary && navigate("/openshifts");
              }, 1000);
            }
          })
          .catch((error) => {
            console.log(error);
            dispatch(setSaveAPIErrors(error.message));
          });
      });
    } else {
      //resetVal()
      navigate("/matchingcandidate", {
        state: {
          matchingJobid: jobShiftUniqueId,
          acceptableTravelDistance: acceptableTravelDistance,
          jobUniqueId: editJobUniqueId,
          createJobPage: !loadJobId ? true : false,
          previousPath: '/jobopportunity',
          postion: postion
        },
      });
    }
  };



  const isErrorExists = (errors) => {
    const errorKeys = Object.keys(errors);
    if (errorKeys.length > 0) {
      return errorKeys.filter((key) => errors[key] !== undefined).length > 0;
    }
    return false;
  };

  const sumbitJobDetails = async (isJobDescription) => {
    let errors = {};
    if (isJobDescription) {
      const description = await dispatch(setJobDescription());
      // if(description === "" || description === "<p><br></p>"){
      //   errors.jobDescription = "Job Description is required";
      // }
    }
    validateJobType(jobType, errors);
    validateStartJob(startJob, errors);
    validateLocationInfo(location, errors);
    validateShiftInfo(shift, errors, recursionFlag, selectedAuthUsers, JobEncounterOccurreneUpdateList);
    validateJobInfo(jobInfo, errors, recursionFlag);
    // validateEducationInfo(education, errors);

    if (filterJobList?.showQATab) {
      validatDynamicForm(formdata, errors, inputTypes);
    }

    // if (filterJobList?.showSpecialties) {
    //   validateMedicalSpecialityInfo(medicalSpeciality, errors);
    // }

    // if (filterJobList?.showCertifications) {
    //   validateCertificationInfo(certification, errors);
    // }

    // if (filterJobList?.showEmr) {
    //   validateEMREHRInfo(emrEhrSystemExperience, errors);
    // }

    // validateCovidInfo(covidVaccinationStatus, errors);
    validateDepsUnits(depsUnits, errors);
    validateOvetimeAllowed(isOvertimeAllowed, errors, selectedOption, recursionFlag);
    validateTemplateInfo(templateInfo, errors, selectedOption);
    validatePayRateInfo(payRateType,recursionFlag,payRateTotalShiftAmount,payRateOccurrenceAmount, errors);
    if (
      jobMultishiftOccurreneUpdateList &&
      !jobMultishiftOccurreneUpdateList.length &&
      rrurle &&
      recursionFlag?.toString() === "3" &&
      shift.startTime?.name &&
      shift.endTime?.name
    ) {
      const startDateFormat = moment(
        shift.date + " " + shift.startTime.name,
        "YYYY-MM-DD H:mm A"
      );
      const endDateFormat = moment(
        shift.date + " " + shift.endTime.name,
        "YYYY-MM-DD H:mm A"
      );

      const calenderRequestBody = {
        TaskID: guid(),
        ownerID: guid(),
        Title: "Shift Info",
        Description: "",
        StartTimezone: null,
        Start: new Date(startDateFormat),
        End: new Date(endDateFormat),
        EndTimezone: null,
        RecurrenceRule: rrurle,
        RecurrenceID: null,
        RecurrenceException: [],
        isAllDay: false,
        locationId: location.locationNameInfo?.id,
        jobsContactsList: location.contactPersons.map(item => item.id),
        jobsApproversList: location.approvalUsers.map(item => item.id),
        billingrate: jobInfo?.billingrate ? jobInfo?.billingrate : '',
        shiftLength: shift.preferedShift?.id ? shift.preferedShift?.id : '',
        editDay: false,
        payRateOccurrenceAmount: (+payRateType === payRateTypeObj.manualCal) ? payRateOccurrenceAmount : null
      };

      dispatch(
        setjobMultishiftOccurreneUpdateList(
          JSON.parse(JSON.stringify([calenderRequestBody]))
        )
      );
    }
    if (isErrorExists(errors)) {

      dispatch(setErrorInfo(errors));
      return false;
    } else {

      dispatch(setErrorInfo({}));
      dispatch(
        pushToSummary(
          jobType,
          startJob,
          location,
          shift,
          jobInfo,
          education,
          medicalSpeciality,
          certification,
          emrEhrSystemExperience,
          covidVaccinationStatus,
          templateInfo,
          login.employerUniqueId,
          formdata,
          rrurle,
          recursionFlag,
          rrurleStr,
          JobEncounterOccurreneUpdateList,
          isAutoPostAllowed,
          isOvertimeAllowed,
          depsUnits,
          payRateType,
          payRateTotalShiftAmount,
          payRateOccurrenceAmount
        )
      );
      return true;
    }
  };

  const backHandler = () => {
    dispatch(setResetDropdown(false));
    navigate("/jobopportunity",{
      state:{
        postion: postion
      }
    });
  };
  return (
    <div className="page main-margin ">
      {/* <Loader /> */}
      {(loadingFlag > 0 || loadingFlagSummary > 0) && <Spinner />}
      <Header />
      <Sidebar />
      <div className="page-main">
        <div ref={jobDetailsTopRef} />

        {/* <BackFixedButton
        btnStyle= {`btn-danger`}
        btnName={'Back'}
        // backPage={backpage}
        /> */}
        <div className="main-content app-content mt-0 main-background ">
          <div className="side-app">
            <div className="main-container container-fluid">
              <div className="page-header">
                <h1 className="page-title">{jobUniqueId ? 'Shift Awaiting Approval' : 'Shift View Details'}</h1>
                <BackAlterButton
                  btnStyle={`btn-danger`}
                  btnName={"Back"}
                  backHandler={backHandler}
                // backPage={backpage}
                />
              </div>
              {jobSaveError !== "" && (
                <>
                  <div
                    className="toast wrap-input100 align-items-center text-white bg-danger border-0 show"
                    role="alert"
                    aria-live="assertive"
                    aria-atomic="true"
                    data-bs-autohide="false"
                  >
                    <div className="d-flex col-6">
                      <div className="toast-body">
                        {jobSaveError || "Save error! Please try again."}
                      </div>
                    </div>
                  </div>
                  <div>&nbsp;</div>
                </>
              )}
              <div className="row">
                <div className="col-xl-12 col-md-12 col-lg-12">
                  <div className="card">
                    <div className="card-body">
                      {dataLoaded && (
                        <div className="row">
                          {
                            jobUniqueId && <JobLocation
                              {...jobDetails}
                              errors={errors}
                              editMode={editMode}
                              sumbitJobDetails={sumbitJobDetails}
                            />
                          }
                          {jobUniqueId && jobDetails?.claimedCandidateInfo && (
                            <ClaimedCandidateInfo
                              PageName={PageName}
                              claimedCandidateInfo={
                                jobDetails?.claimedCandidateInfo
                              }
                              jobDetails={jobDetails}
                              candidateBillingsInfo={
                                jobDetails?.candidateBillingsInfo
                              }
                              jobId={jobUniqueId}
                              jobClaimId={jobsClaimId}
                              jobDate={jobDate}
                              jobShiftUniqueId={jobShiftUniqueId}
                              shiftType={shiftType}
                              currentShiftDate={jobDate}
                              shift={shift}
                              editMode={editMode}
                              encounterOccurrence={
                                JobEncounterOccurreneUpdateList
                              }
                              jobEncounterOccurreneList={
                                jobDetails?.jobEncounterOccurreneList
                              }
                            />
                          )}
                          {/* {jobUniqueId && (
                            <ClaimedCandidateInfoSection
                            {...jobDetails}
                            PageName={PageName}
                              claimedCandidateInfo={
                                jobDetails?.claimedCandidateInfo
                              }
                              candidateBillingsInfo={
                                jobDetails?.candidateBillingsInfo
                              }
                              jobId={jobUniqueId}
                              jobClaimId={jobsClaimId}
                              jobDate={jobDate}
                              jobShiftUniqueId={jobShiftUniqueId}
                              shiftType={shiftType}
                              currentShiftDate={jobDate}
                              shift={shift}
                              editMode={editMode}
                              encounterOccurrence={
                                JobEncounterOccurreneUpdateList
                              }
                              jobEncounterOccurreneList={
                                jobDetails?.jobEncounterOccurreneList
                              }
                            />
                          )} */}
                          {/* {!editMode && (jobDetails?.deletedOccurence?.length || jobDetails?.modifiedOccurreneList?.length) ? <OccurrenceDetail {...jobDetails} />:""} */}
                          {/* <JobType {...jobDetails} errors={errors}  editMode={false} sumbitJobDetails={sumbitJobDetails} /> */}
                          {
                            !jobUniqueId && <JobLocation
                              {...jobDetails}
                              errors={errors}
                              editMode={editMode}
                              sumbitJobDetails={sumbitJobDetails}
                            />
                          }
                          {
                            !jobUniqueId && <PayRateSummary
                              {...jobDetails}
                              errors={errors}
                              editMode={editMode}
                              sumbitJobDetails={sumbitJobDetails}
                            />
                          }
                          {
                            !jobUniqueId ? <Shift
                              {...jobDetails}
                              currentShiftDate={jobDate}
                              shift={shift}
                              errors={errors}
                              editMode={editMode}
                              sumbitJobDetails={sumbitJobDetails}
                              encounterOccurrence={
                                JobEncounterOccurreneUpdateList
                              }
                              jobEncounterOccurreneList={
                                jobDetails?.jobEncounterOccurreneList
                              }
                            /> : ""
                          }

                          {!jobUniqueId && <JobInfo
                            {...jobDetails}
                            currentShiftDate={jobDate}
                            errors={errors}
                            jobDescription={
                              jobDetails.jobDescription ||
                              jobInfo?.jobDescription
                            }
                            editMode={editMode}
                            sumbitJobDetails={sumbitJobDetails}
                          />}
                          <div className="row ps-0 pe-0">
                            <div className="col-md-6 col-lg-6 pe-0 mb-4">
                              <Education
                                {...jobDetails}
                                errors={errors}
                                editMode={editMode}
                                sumbitJobDetails={sumbitJobDetails}
                              />
                            </div>
                            {filterJobList?.showSpecialties && (
                              <>
                                <div className="col-md-6 col-lg-6 pe-0 mb-4">
                                  <MedicalSpeciality
                                    {...jobDetails}
                                    errors={errors}
                                    editMode={editMode}
                                    sumbitJobDetails={sumbitJobDetails}
                                  />
                                </div>
                              </>
                            )}

                            {filterJobList?.showCertifications && (
                              <>
                                <div className="col-md-6 col-lg-6 pe-0 mb-4">
                                  <Certification
                                    {...jobDetails}
                                    errors={errors}
                                    editMode={editMode}
                                    sumbitJobDetails={sumbitJobDetails}
                                  />
                                </div>
                              </>
                            )}
                            {filterJobList?.showEmr && (
                              <>
                                <div className="col-md-6 col-lg-6 pe-0 mb-4">
                                  <EMREHRExperience
                                    {...jobDetails}
                                    errors={errors}
                                    editMode={editMode}
                                    sumbitJobDetails={sumbitJobDetails}
                                  />
                                </div>
                              </>
                            )}

                            <div className="col-md-6 col-lg-6 pe-0 mb-4">
                              <CovidVaccine
                                {...jobDetails}
                                errors={errors}
                                editMode={editMode}
                                masterData={masterData}
                                sumbitJobDetails={sumbitJobDetails}
                              />
                            </div>

                            {
                              jobUniqueId ? (parseInt(jobDetails?.jobSummeryJobsShifts?.shiftType) === 1 || parseInt(jobDetails?.jobSummeryJobsShifts?.shiftType) === 3) && <div className="col-md-6 col-lg-6 pe-0 mb-4">
                                <AutoRepost
                                  {...jobDetails}
                                  editMode={editMode}
                                  sumbitJobDetails={sumbitJobDetails}
                                />
                              </div> : (parseInt(recursionFlag) === 1 || parseInt(recursionFlag) === 3) && <div className="col-md-6 col-lg-6 pe-0 mb-4">
                                <AutoRepost
                                  {...jobDetails}
                                  editMode={editMode}
                                  sumbitJobDetails={sumbitJobDetails}
                                />
                              </div>
                            }

                            {/* {(parseInt(recursionFlag) === 1 || parseInt(recursionFlag) === 3 || parseInt(jobDetails?.jobSummeryJobsShifts?.shiftType) === 1 || parseInt(jobDetails?.jobSummeryJobsShifts?.shiftType )=== 3) ?
                              <div className="col-md-6 col-lg-6 pe-0 mb-4">
                                <AutoRepost
                                  {...jobDetails}
                                  editMode={editMode}
                                  sumbitJobDetails={sumbitJobDetails}
                                />
                              </div> : ""
                            } */}
                            {filterJobList?.jobTypeId && login?.accountFlags?.isShowQATab && (
                              <div className="col-md-6 col-lg-6 pe-0 mb-4">
                                <SummaryDyanamicJob
                                  errors={errors}
                                  {...jobDetails}
                                  editMode={editMode}
                                  sumbitJobDetails={sumbitJobDetails}
                                />
                              </div>
                            )}
                            <div style={{ display: "grid", gridTemplateColumns: "repeat(2,minmax(0,1fr))", rowGap: "1.25rem", columnGap: "1rem" }} className="">
                              <DepsUnitsSummary
                                errors={errors}
                                {...jobDetails}
                                editMode={editMode}
                                sumbitJobDetails={sumbitJobDetails} />
                              {selectedOption?.createTemplate ? "" : ((parseInt(recursionFlag) !== 2) && <OvertimeAllowed errors={errors}

                                {...jobDetails}
                                editMode={editMode}
                                sumbitJobDetails={sumbitJobDetails}
                              />)}
                              {
                                !jobUniqueId && recursionFlag?.toString() !== "2" && (<div >
                                  <div className="card h-100">
                                    <div className="card-header">
                                      <b><h5 className="mb-0">Markup</h5></b>
                                    </div>
                                    <div className="card-body">
                                      <div>Variable Shift Markup: {checkMarkup?.variableshiftmarkup?.length ? <span style={{ color: 'green' }}>Yes</span> : <span style={{ color: 'red' }}>NO</span>}</div>
                                      <div>Mileage Markup: {checkMarkup?.mileagemarkup?.length ? <span style={{ color: 'green' }}>Yes</span> : <span style={{ color: 'red' }}>NO</span>}</div>
                                    </div>
                                  </div>
                                </div>)
                              }
                              {
!postion?.editJobPost ? 

                              <TemplateInfo
                                {...jobDetails}
                                errors={errors}
                                editMode={editMode}
                                sumbitJobDetails={sumbitJobDetails}
                              /> : ''

                              }
                            </div>
                          </div>


                          {/* <TemplateInfo
                            {...jobDetails}
                            errors={errors}
                            editMode={editMode}
                            sumbitJobDetails={sumbitJobDetails}
                          /> */}
                        </div>
                      )}
                    </div>
                    <div className="card-body ">
                      <div className="d-flex flex-row float-sm-end">
                        {gotoMatching && !jobUniqueId && (
                          <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end me-2">
                            {jobDetails?.claimedCandidateInfo?.isClaimed ? (
                              ""
                            ) : (
                              <button
                                className="btn btn-primary sw-btn-next justify-content-right"
                                type="button"
                                disabled={
                                  jobDetails?.claimedCandidateInfo?.isClaimed
                                }
                                onClick={saveJobMatching}
                              >
                                {save
                                  ? recursionFlag?.toString() === "2"
                                    ? "Assign"
                                    : "Save and view candidates"
                                  : "View matching candidates"}
                              </button>
                            )}
                          </div>
                        )}
                        {editMode &&
                          (selectedOption?.createTemplate ||
                            postion?.createTemplate) && (
                            <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end">
                              <button
                                className="btn btn-primary sw-btn-next justify-content-right"
                                type="button"
                                onClick={postJob}
                              >
                                {selectedOption?.createTemplate ||
                                  postion?.createTemplate
                                  ? "Save a Template"
                                  : "Post the job"}
                              </button>
                            </div>
                          )}
                      </div>
                      <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-left">
                        <div
                          className="btn-group me-2 sw-btn-group prev-margin"
                          role="group"
                        >
                          <button
                            className={`btn btn-danger sw-btn-prev`}
                            type="button"
                            onClick={() => {
                              // dispatch(editPost())
                              dispatch(setResetDropdown(false));
                              navigate("/jobopportunity",{
                                state:{
                                  postion: postion
                                }
                              });
                            }}
                          >
                            Back
                          </button>
                        </div>
                      </div>
                      <div className="pull-right mt-3">
                        <BackAlterButton
                          btnStyle={`btn-danger`}
                          btnName={"Back"}
                          backHandler={backHandler}
                        // backPage={backpage}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
};
